import { initSiteSegmentMigration } from './initDesignItem';
import { editorModel } from '#packages/util';

import type { Scope } from './scope';

export async function init(scope: Scope) {
  const { isInsideEditorX, isInsideAppStudio } = scope.editorParamsAPI;
  const isEnvNotSupportedForMigration =
    isInsideEditorX || isInsideAppStudio || editorModel.isImpersonated;

  if (isEnvNotSupportedForMigration) {
    scope.siteSegmentMediaBgMigrationHook.resolve();
    return;
  }

  scope.editorCoreApi.addToEditorInit(
    scope.siteSegmentMediaBgMigrationHook.promise,
  );
  await scope.editorCoreApi.hooks._dsIsReady.promise;
  await scope.editorCoreApi.hooks.sectionsMigrationReady.promise;

  await initSiteSegmentMigration(scope);
}
